import AudioPlayer from "react-h5-audio-player";

import styled from "@emotion/styled";
import { Download } from "@mui/icons-material";
import { Box } from "@mui/material";

import PalIconButton from "~components/mui/PalIconButton";

import SimpleMessage from "./SimpleMessage";

import "react-h5-audio-player/src/styles.scss";

const StyledAudioPlayer = styled(AudioPlayer)`
  &.rhap_container {
    box-shadow: none;
    border: none;
    background-color: transparent;
    width: 100%;
    max-width: 600px;
    min-width: 300px;
    padding: 0;
    svg {
      color: rgba(0, 0, 0, 0.54);
    }
    .rhap_controls-section {
      max-width: max-content;
      min-width: 0;
      width: auto;
    }
    .rhap_current-time,
    .rhap_total-time {
      color: inherit !important;
    }
  }
`;

export default function AudioMessage({
  plainView,
  format,
  position,
  messageTime,
  isSent,
  messageId,
  likeStatus,
  historyId,
  isLast,
  className,
  files,
}) {
  const singleFile = files?.[0];
  const url = singleFile?.url || singleFile?.file_url;

  const handleClickAudioDownload = (e) => {
    e.stopPropagation();
    e.preventDefault();

    const url = singleFile?.url || singleFile?.file_url;
    if (url) {
      window.open(url, "_blank");
    }
  };
  return (
    <SimpleMessage
      isImage
      format={format}
      historyId={historyId}
      isLast={isLast}
      isSent={isSent}
      likeStatus={likeStatus}
      messageId={messageId}
      messageTime={messageTime}
      position={position}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <StyledAudioPlayer
          controls
          autoPlay={false}
          className={className}
          customVolumeControls={[]}
          layout="horizontal"
          showDownloadProgress={true}
          showFilledVolume={false}
          showJumpControls={false}
          showSkipControls={false}
          src={url}
          volume={1}
        />
        <PalIconButton
          sx={{
            "&.MuiIconButton-root.MuiIconButton-sizeMedium": {
              width: 38,
              height: 38,
            },
          }}
          onClick={handleClickAudioDownload}
        >
          <Download />
        </PalIconButton>
      </Box>
    </SimpleMessage>
  );
}
